import type { FaireProductEntity } from "../../entity_types/product";

export const p_285uz3gszw: FaireProductEntity = {
  token: "p_285uz3gszw",
  type: "product",
  name: "Cape Floral Non-alcoholic Gin Alternative",
  brandToken: "b_g593ctghc8",
  brandName: "Abstinence Spirits",
  imageUrl:
    "https://cdn.faire.com/fastly/a7edace253e44fc4b0b655bbb53ff2a1569ded33e93b36fa757bbebbf2665b17.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa6e7589b9a8189175d733683b05d7da1172c0229418424c62ef67344d3720d6.jpeg",
    "https://cdn.faire.com/fastly/c10ac3f6df34fdb9bf5c61c2222f86376d38cc2b69828f606170923b2c208b4f.jpeg",
    "https://cdn.faire.com/fastly/81aa2c7341483e1c397888a4a4042b3231e65e2b0ff9fcf574e3f0ffde2cfbb7.png",
  ],
  priceDollars: 33.95,
  description:
    "Inspired by the astounding biodiversity of the Cape Floral Kingdom, the Cape Fynbos draws its inspiration from the hero ingredient - the indigenous Cape Rose Geranium. A beautifully floral creation with the addition of Juniper berries, Angelica root and Coriander. A slightly bitter, slightly herbal, and faintly nettle-like creation that pairs well with premium tonics.\n\nNO SUGAR | NO ARTIFICAL SWEETENERS | NO COLORANTS\n\nBotanicals: Rose Geranium, Juniper, Angelica Root, Coriander, Lemon\n",
  tags: [],
  msrpDollars: 48.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:42.748Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
